<script>
export default {
  name: 'TransactionShippingInfo',
  props: {
    payloadResponse: {
      type: Object,
      required: true
    },
    maskedShippingAddress: {
      type: Object,
      required: true
    },
    maskedConsumer: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div
    id="transaction-shipping-info"
    class="mb-4 mt-4"
  >
    <h4 class="font-weight-bold mb-4">
      {{ $t ('header.shippingInformation') }}
    </h4>
    <div>
      <div
        id="shipping-recipient"
        data-test="shipping-recipient"
      >
        {{ (maskedShippingAddress ||{}).name || '' }}
      </div>
      <div
        id="shipping-country-code"
        data-test="shipping-country-zip"
      >
        {{ payloadResponse.shippingCountryCode }} {{ payloadResponse.shippingAddressZip }}
      </div>
      <div
        id="shipping-phone"
        data-test="shipping-phone-number"
      >
        {{ (maskedConsumer.maskedConsumerMobileNumber || {}).phoneNumber }}
      </div>
      <div
        id="shipping-email"
        data-test="shipping-email"
      >
        {{ maskedConsumer.maskedEmailAddress }}
      </div>
      <div class="mt-3">
        <label>
          {{ $t ('label.shippingMethod') }}
        </label>
        <div
          id="shipping-method"
          data-test="shipping-method"
        >
          {{ $t ('label.shippingMethodType') }}
        </div>
      </div>
    </div>
  </div>
</template>
